export default {
    state: {
        wysiwyg_menu_type: 'bubble',
        dark_mode: false,

        // article settings
        show_student_edition: true,
        show_teacher_edition: true,
        lexile_certified_score_editable: false
    },
    mutations: {
        setWYSIWYGMenuType(state, payload) {
            state.wysiwyg_menu_type = payload
        },
        // article settings
        setShowStudentEdition(state, payload) {
            state.show_student_edition = payload
        },
        setShowTeacherEdition(state, payload) {
            state.show_teacher_edition = payload
        },
        setLexileCertifiedScoreEditable(state, payload) {
            state.lexile_certified_score_editable = payload
        }
    },
    actions: {}
}
